// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__24krK","wrapper":"style_wrapper__3O0jT","parentContainer":"style_parentContainer__tD8kt"};